// extracted by mini-css-extract-plugin
module.exports = {"section":"Collapsable_section__c1xiG","content":"Collapsable_content__2Arvd","sectionTitle":"Collapsable_sectionTitle__J-qgk"};